import ceilingHung from '../../assets/equipment/ceiling-hung.webp'
import wallFixed from '../../assets/equipment/wall-fixed.webp'
import competitionPortable from '../../assets/equipment/competition-portable.webp'
import mobileQuick from '../../assets/equipment/mobile-quick.webp'
import outdoor from '../../assets/equipment/outdoor.webp'
import backboardsRims from '../../assets/equipment/backboards-rims.webp'
import scoreboards from '../../assets/equipment/scoreboards.webp'
import wallPadding from '../../assets/equipment/wall-padding.webp'
import dividerCurtains from '../../assets/equipment/divider-curtains.webp'
import floorProtection from '../../assets/equipment/floor-protection.webp'

export type Equipment = {
    slug: string
    name: string
    note: string
    image: string
    // Catalogue cut-outs sit on white and must not be cropped; photographs fill
    // the frame instead.
    isCutout?: boolean
}

// Shared by the home page's Division 03 block and the /facility-equipment
// listing, so the two never drift apart.
export const EQUIPMENT: Equipment[] = [
    { slug: 'ceiling-hung-backstops', name: 'Ceiling-hung backstops', note: 'Roof-fixed, side and rear folding', image: ceilingHung },
    { slug: 'wall-fixed-backstops', name: 'Wall-fixed backstops', note: 'Swing-up and fold-away frames', image: wallFixed },
    { slug: 'competition-portable-backstops', name: 'Competition portable backstops', note: 'FIBA-format match units', image: competitionPortable },
    { slug: 'mobile-and-quick-assembly', name: 'Mobile and quick-assembly', note: 'Roll-out training backstops', image: mobileQuick },
    { slug: 'outdoor-portable-and-fixed', name: 'Outdoor portable and fixed', note: 'Weather-rated ground units', image: outdoor, isCutout: true },
    { slug: 'backboards-rims-and-adjusters', name: 'Backboards, rims and adjusters', note: 'Glass and acrylic, height adjusters', image: backboardsRims, isCutout: true },
    { slug: 'scoreboards-and-timing', name: 'Scoreboards and timing', note: 'Shot clocks and match timers', image: scoreboards, isCutout: true },
    { slug: 'wall-padding', name: 'Wall padding', note: 'Impact padding to court perimeter', image: wallPadding },
    { slug: 'divider-curtains', name: 'Divider curtains', note: 'Motorised hall division', image: dividerCurtains },
    { slug: 'floor-protection-and-mat-handling', name: 'Floor protection and mat handling', note: 'Cover systems and carts', image: floorProtection },
]

export const EQUIPMENT_PATH = '/facility-equipment'
